import ContributorShare from './ContributorShare';

export default ContributorShare;
